import { useEffect, useState } from "react";
import arrowRight from "../../../Assets/images/arrow-right.svg";
import { useNavigate } from "react-router-dom";
import { sendUpdatedContact } from "../../../Services/settingsServices";
import PhoneInput from "react-phone-number-input";
import "react-phone-number-input/style.css";
import { parsePhoneNumberFromString } from "libphonenumber-js";
import Loader from "react-js-loader";

function PhoneSettingsScreen2({ onUpdateContactClick, currentPhone }) {
  const [newMobileNumber, setNewMobileNumber] = useState("");
  const [defaultCountry, setDefaultCountry] = useState("US");
  const [isLoading, setIsLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    if (errorMessage) {
      const timer = setTimeout(() => {
        setErrorMessage("");
      }, 3000); // 3000 ms = 3 seconds

      return () => clearTimeout(timer); // cleanup on unmount or error change
    }
  }, [errorMessage]);

  useEffect(() => {
    if (!currentPhone) return;
    try {
      const parsed = parsePhoneNumberFromString(currentPhone);
      if (parsed?.country) {
        setDefaultCountry(parsed.country);
      }
      setNewMobileNumber(currentPhone);
    } catch (error) {
      // Fallbacks keep defaults without blocking user edits
      setNewMobileNumber(currentPhone);
    }
  }, [currentPhone]);

  const parsePhoneNumber = (phoneNumber) => {
    const parsed = parsePhoneNumberFromString(phoneNumber);
    if (!parsed) {
      throw new Error("Invalid phone number format");
    }
    return parsed;
  };

  const onUpdateContact = async () => {
    if (isLoading) return; // Prevent multiple clicks
    setIsLoading(true);
    setErrorMessage(""); // Reset previous errors

    if (!newMobileNumber) {
      setErrorMessage("Please enter a valid phone number.");
      setIsLoading(false);
      return;
    }

    try {
      const parsedPhoneNumber = parsePhoneNumber(newMobileNumber);
      const country_code = `+${parsedPhoneNumber.countryCallingCode}`;
      const contact = parsedPhoneNumber.nationalNumber;

      if (currentPhone === newMobileNumber) {
        setErrorMessage("Please enter a different number.");
        return;
      }

      const response = await sendUpdatedContact({
        country_code: country_code,
        contact: contact,
      });

      const payload = response?.payload;
      if (payload.success) {
        setSuccessMessage("Message sent successfully!");
        sessionStorage.setItem("newcountryCode", country_code);
        sessionStorage.setItem("newContact", contact);
        setTimeout(() => {
          onUpdateContactClick();
        }, 2000);
      } else {
        throw new Error(response || "Failed to update contact.");
      }
    } catch (error) {
      setErrorMessage(error?.response?.data?.message || "Something went wrong !");
      console.error("Error updating contact:", error);
    } finally {
      setIsLoading(false); // Reset button state
    }
  };

  return (
    <div className="set-phone-modal-container">
      {isLoading && (
        <div className="loader-df-container">
          <Loader type="spinner-cub" bgColor={"#2D50A7"} color={"#3D6DEB"} size={45} />
        </div>
      )}
      <div>
        <div className="set-phone-modal-head">Edit Phone Number</div>
      </div>
      <div className="set-phone-int-cnt">
        <div className="set-phone-modal-input-container">
          <div className="set-phone-input-label">Phone Number</div>
          <div className="set-phone-input-field" onClick={(e) => e.stopPropagation()}>
            <PhoneInput
              international
              defaultCountry={defaultCountry}
              countryCallingCodeEditable={false}
              value={newMobileNumber}
              onChange={setNewMobileNumber}
              placeholder="+1 (555) 000-0000"
              className="set-phone-phone-input"
            />
          </div>
        </div>
        {errorMessage && (
          <div
            style={{
              color: "red",
              textAlign: "center",
            }}
          >
            {errorMessage}
          </div>
        )}
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            marginBottom: "20px",
            marginTop: "20px",
          }}
        >
          <button
            className="set-phone-continue-button"
            onClick={onUpdateContact}
            style={{
              cursor: isLoading ? "not-allowed" : "pointer",
              opacity: isLoading ? "0.6" : "1",
            }}
          >
            Continue <img src={arrowRight} alt="continue" />
          </button>
        </div>
      </div>
    </div>
  );
}

export default PhoneSettingsScreen2;
